export function mountGlide() {
    const sliders = document.querySelectorAll('.glide');

    if (sliders.length > 0) {
        sliders.forEach(slider => {
            const id = slider.getAttribute('data-id');
            if (document.getElementById('glide-' + id)) {
                new Glide('#glide-' + id, {
                    gap: 0,
                    keyboard: true,
                    animationDuration: 750,
                    autoplay: 6000,
                }).mount();
            }
        });
    }
}
